module.exports = __webpack_public_path__ + "img/ad_coupon2.fb273415.png";